import { IStorageService } from "./storage-service";

export class LocalStorageService<T extends string> implements IStorageService<T> {

    private APP_NAME: string;

    constructor(appName: string) {
        this.APP_NAME = appName;
    }

    clear(): void {
        window.localStorage.clear();
    }

    getItem(key: T): string | null {
        return window.localStorage.getItem(this.APP_NAME + "-" + key);
    }

    getLength(): number {
        return window.localStorage.length;
    }

    // key(index: number): string | null {
    //     return window.localStorage.key(index);
    // }

    removeItem(key: T): void {
        return window.localStorage.removeItem(this.APP_NAME + "-" + key);
    }

    setItem(key: T, value: string): void {
        window.localStorage.setItem(this.APP_NAME + "-" + key, value);
    }
}